<lib-generic-select-form-control
  ngDefaultControl
  [dataProvider]="dataProvider"
  [labelField]="labelField"
  [valueField]="valueField"
  [placeholder]="placeholder"
  [formControl]="control"
  [labelFunction]="labelFunction"
  [formControlId]="formControlId"
></lib-generic-select-form-control>
